"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { Post } from "@/shared/libs/axios/request";
import { itemKeys } from "@/entities/item";
import type { ItemImageResponse } from "@stocks/shared";

/** 품목 사진 1장 업로드 (실패 시 장별 재시도를 위해 파일 단위로 호출한다). */
export const useUploadItemImage = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ itemId, file }: { itemId: string; file: File }) => {
      const form = new FormData();
      form.append("itemId", itemId);
      form.append("files", file);
      const res = await Post<ItemImageResponse[], FormData>(
        "/v1/file/upload-multiple",
        form,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      return res.data.data?.[0];
    },
    onSuccess: (_data, { itemId }) =>
      qc.invalidateQueries({ queryKey: itemKeys.images(itemId) }),
  });
};
